function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
import { FETCH_PRODUCT_DEPOSIT_TEMPLATES, FETCH_PRODUCT_DEPOSIT_TEMPLATE, RECEIVE_DEPOSIT_TEMPLATES, RECEIVE_DEPOSIT_TEMPLATES_ERROR, RECEIVE_DEPOSIT_TEMPLATE, RECEIVE_DEPOSIT_TEMPLATE_ERROR, RECEIVE_DEPOSIT_INFO, RECEIVE_DEPOSIT_TICKET, RECEIVE_DEPOSIT_TICKETS, FETCH_DEPOSIT_INFO, RECEIVE_DEPOSIT_INFO_ERROR, RESET_DEPOSIT_INFO, ADD_DEPOSIT } from '../actions/depositActions';
import { CLOSE_SIDE_PANE } from '../actions/sidePaneActions';
import { distinct } from '../../helpers/arrayHelper';
var initialState = {
  templateInfo: {},
  template: {},
  templateTypes: [],
  error: '',
  isLoading: false,
  depositInfo: [],
  depositStatus: {},
  depositsStatus: [],
  product: 0
};
export default function deposit() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case FETCH_PRODUCT_DEPOSIT_TEMPLATES:
    case FETCH_PRODUCT_DEPOSIT_TEMPLATE:
      return Object.assign({}, state, {
        error: '',
        isLoading: true,
        product: payload.product,
        templateType: payload.templateType
      });
    case FETCH_DEPOSIT_INFO:
      return Object.assign({}, state, {
        error: '',
        isLoading: true,
        product: payload.product
      });
    case RECEIVE_DEPOSIT_TEMPLATES:
      {
        return Object.assign({}, state, {
          error: '',
          product: state.product,
          templateTypes: payload,
          isLoading: false
        });
      }
    case RECEIVE_DEPOSIT_TEMPLATE:
      {
        return Object.assign({}, state, {
          error: '',
          product: state.product,
          templateInfo: payload.Template,
          template: JSON.parse(payload.Template.Template),
          isLoading: false
        });
      }
    case RECEIVE_DEPOSIT_TEMPLATES_ERROR:
    case RECEIVE_DEPOSIT_TEMPLATE_ERROR:
    case RECEIVE_DEPOSIT_INFO_ERROR:
      {
        return Object.assign({}, state, {
          error: payload,
          isLoading: false
        });
      }
    case RECEIVE_DEPOSIT_INFO:
      {
        return Object.assign({}, state, {
          error: '',
          isLoading: false,
          depositInfo: payload
        });
      }
    case RECEIVE_DEPOSIT_TICKET:
      {
        return Object.assign({}, state, {
          error: '',
          depositStatus: payload
        });
      }
    case ADD_DEPOSIT:
      {
        return Object.assign({}, state, {
          depositsStatus: distinct([payload].concat(_toConsumableArray(state.depositsStatus)), function (deposit) {
            return deposit.ReferenceId;
          })
        });
      }
    case RECEIVE_DEPOSIT_TICKETS:
      {
        return Object.assign({}, state, {
          error: '',
          depositsStatus: payload
        });
      }
    case CLOSE_SIDE_PANE:
      {
        return Object.assign({}, initialState, {
          depositsStatus: state.depositsStatus
        });
      }
    case RESET_DEPOSIT_INFO:
      {
        return state;
      }
    default:
      return state;
  }
}